/*
 * One source for the project's public channels. The Footer used to own this
 * list inline, which is why the Community page had nothing to build on.
 *
 * `role` marks what a channel is actually for, so the Community page can group
 * them instead of showing nine equal icons.
 */
export const CONTACT_EMAIL = 'dimensionxlive@gmail.com';

export const socialLinks = [
    {
        name: 'Discord',
        url: 'https://discord.gg/d8Y8hN39mf',
        icon: 'fab fa-discord',
        role: 'play',
    },
    {
        name: 'Telegram',
        url: 'https://t.me/dimensionxlive',
        icon: 'fab fa-telegram-plane',
        role: 'play',
    },
    {
        name: 'Facebook',
        url: 'https://www.facebook.com/groups/1290551983081540',
        icon: 'fab fa-facebook-f',
        role: 'follow',
    },
    {
        name: 'Instagram',
        url: 'https://www.instagram.com/dimensionxlive/',
        icon: 'fab fa-instagram',
        role: 'follow',
    },
    {
        name: 'TikTok',
        url: 'https://www.tiktok.com/@dimensionxlive',
        icon: 'fab fa-tiktok',
        role: 'follow',
    },
    {
        name: 'YouTube',
        url: 'https://www.youtube.com/@moaddib666',
        icon: 'fab fa-youtube',
        role: 'follow',
    },
    {
        name: 'Patreon',
        url: 'https://www.patreon.com/c/dimension_x_live',
        icon: 'fab fa-patreon',
        role: 'support',
    },
    {
        name: 'GitHub',
        url: 'https://github.com/moaddib666/dx',
        icon: 'fab fa-github',
        role: 'support',
    },
    {
        name: 'Gmail',
        url: `mailto:${CONTACT_EMAIL}`,
        icon: 'fas fa-envelope',
        role: 'support',
    },
];

export const linksByRole = (role) => socialLinks.filter((link) => link.role === role);
